import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

const options = {
  color: '#356ccc',
  failedColor: '#dc3545',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  // autoRevert: true,
  // location: 'left',
  // inverse: false,
};

Vue.use(VueProgressBar, options);



// WEBPACK FOOTER //
// ./src/plugins/vue-progress.js